export default __webpack_public_path__ + "static/media/School_4.7ea2a8ad.jpg";